// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BarChart_wrapper_3b2Em","bar":"BarChart_bar_1FeXh","barResize":"BarChart_barResize_sSTRU","barActive":"BarChart_barActive_VEZ4B","text":"BarChart_text_30vPg"};